(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2838],{

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 61842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-19oeg9l-0"
})(["border:1px solid #707070;padding:30px 25px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-19oeg9l-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'' counter(number) '.';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 73799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitleDiv, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleDiv, {
        children: children
      })
    })
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-1mt88t8-0"
})(["display:flex;flex-direction:column;row-gap:10px;text-align:center;font-weight:bold;color:", ";@media screen and (max-width:1047px){color:", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var FontStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:26px;letter-spacing:0;"]);
var TitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__TitleDiv",
  componentId: "sc-1mt88t8-1"
})(["h2{font-weight:bold;font-size:40px;letter-spacing:1.6px;line-height:50px;span{font-size:30px;letter-spacing:1.2px;}}@media screen and (max-width:1047px){h2{line-height:37px;", " span{", "}}}"], FontStyle, FontStyle);

/***/ }),

/***/ 91465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-1vdak17-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-1vdak17-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-1vdak17-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-1vdak17-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-1vdak17-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-1vdak17-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-1vdak17-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-1vdak17-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08Note' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-1vdak17-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-1vdak17-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 79837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PrivacyPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/enpages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(91465);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Legal/Privacy/PrivacyItems.tsx





var pvItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "1. Collection and Management of Personal Information"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group asks Customers to register their personal information after confirming the purpose of use for Customers to use services. Personal information collected during purchases, inquiries, etc. is strictly managed to prevent unauthorized access, loss, falsification, leakage, etc. Specifically, TRIAL Group has implemented the following security control measures."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "1.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Appoint the persons responsible for the handling of personal information at each company within the TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Clarify the employees who handle personal information as well as the scope of personal information handled by such employees and establish a system for reporting to and contacting the person in charge in case of ascertaining facts or indications of the violation of the Personal Information Protection Acts or internal regulation regarding the handling of personal information."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Regularly educate employees about matters of concern regarding the handling of personal information."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Implement measures to prevent unauthorized persons from viewing personal information in areas where personal information is handled."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Implement access control to limit the persons in charge and the scope of personal information handled."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Personal information collected by TRIAL Group is information that can identify a specific individual (such as name, address, telephone number, fax number, e-mail address, etc.) provided by the Customers, etc.  at the time of various inquiries, procedures, or submission of various certifications and official documents. Personal information also includes information that may not be used to identify a specific individual by itself but may be easily cross-checked with other information to identify a specific individual as a result.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Although sufficient security measures are taken on the Websites to protect personal information from unauthorized access, leakage, falsification, destruction, etc., these measures do not apply to the process by which the signal reaches the Websites from the Customers' computers. Customers are required to manage the security by themselves."]
    })]
  }),
  id: 'privacy1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "2. Purpose of Use"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Personal information of the Customers managed by TRIAL Group shall not be used beyond the following purposes without the prior consent of the Customers."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Confirmation and fulfillment of transactions related to products and services, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Delivery procedures for ordered products, checked packages, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Screening of TRIAL prepaid card membership applications."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Confirmation and cancellation of reservations for products and services, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "After-sales service related to products and services, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Management of purchase points and usage status."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Planning and implementation of events, campaigns, benefits, preferential treatment, discounts, and similar initiatives regarding products and services, etc. of TRIAL Group or third parties."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Shipping of products related to events, campaigns, benefits, preferential treatment, etc. regarding products and services, and similar initiatives of TRIAL Group or third parties."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Confirmation of the contents of inquiries or comments and provision of customer support."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Advertisements or other marketing activities related to products and services, etc. of TRIAL Group or third parties and delivery and distribution of information materials, mail magazines, and direct mail."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Implementation of questionnaires related to  products and services, etc of TRIAL Group or third parties."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Development, improvement, and research on products and services, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Implementation of various recruitment events, recruitment selection, and employment management for employees."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Maintenance and management of facilities and equipment."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Payment settlement and credit management."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Market research, ascertainment of sales floor conditions, analysis of customer trends, analysis of the use of products and services, etc., and other research and analyses necessary for management as well as the preparation of data for such purposes (including the preparation of various statistical information)."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Crime prevention and safety measures, fraud detection and the measures taken for the fraud."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Purposes of use separately disclosed to Customers or publicly announced."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Management of shareholders and providing information for shareholders in accordance with the Companies Act, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Notifications related to the above and other emergency contacts."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Purposes incidental to the above."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["*As part of the marketing activities in (10), the TRIAL Group may link user lists including Customers, etc., held by Google, LINE, and other advertisement-related operators (hereinafter referred to as \"Advertisement-related Operators\") (limited to lists of users for whom the Advertisement-related Operators have obtained prior consent for third-party provision), with information held by the TRIAL Group such as e-mail addresses, telephone numbers, cookies, and other information necessary to identify users, in order to provide suggestions, information, and advertisement distribution regarding the services of the TRIAL Group or third parties (hereinafter referred to as \"Suggestions, etc.\") to users who meet certain conditions (including users of the TRIAL Group's services and services provided by Advertisement-related Operators).", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "In addition, as part of the marketing activities in (10), the TRIAL Group may acquire personally referable information such as cookies, location information, and advertising identifiers from Advertisement-related Operators, and may provide Suggestions, etc., to Customers, etc., by linking such personally referable information with the personal information of Customers, etc., already held by the TRIAL Group. When performing such linking, the TRIAL Group shall do so only after obtaining prior consent from the subject Customers, etc."]
      })]
    })]
  }),
  id: 'privacy2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "3. Jointly Utilization of Personal Information"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["TRIAL Group and SU-PAY Co., Ltd. may jointly utilize the personal information in their possession within TRIAL Group with appropriate protection measures within the scope of \"2. Purpose of Use\" as set forth below.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*Click ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
        path: "/en/legal/privacy-policy/joint-utilization",
        text: "here"
      }), " for information on the joint utilization of personal information between TRIAL Group and SU-PAY Co., Ltd."]
    })]
  }),
  id: 'privacy3'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "4. Provision to Third Parties"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group may outsource all or part of the handling of acquired personal information to third parties to the extent necessary to achieve the purpose of use. In such cases, TRIAL Group shall conclude necessary contracts such as contracts for the protection of personal information and implement necessary and appropriate supervision of such third parties."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "For the purpose of use set forth in Article 2, TRIAL Group may provide personal information and personally referable information of Customers, etc. to third parties after obtaining prior consent from Customers, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group shall not provide collected personal information to third parties, except in the case set forth in the preceding paragraphs of this Article or in the case of joint use. However, this shall not apply in cases where consent has been obtained by the Customers,etc. or permitted by law."
      })]
    })]
  }),
  id: 'privacy4'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "5. Provision to Third Parties Located in Foreign Countries"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "When TRIAL Group provides personal information to third parties located in foreign countries, TRIAL Group shall take necessary measures such as obtaining consent in accordance with laws and regulations."
    })]
  }),
  id: 'privacy5'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "6. Use of Anonymously Processed Information"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group may produce anonymously processed information based on personal information provided by Customers, which is processed in such a way individuals shall not be identified. TRIAL Group shall comply with the following points regarding the handling of anonymously processed information."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Matters Concerning Safety Control Measures", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "TRIAL Group shall take necessary and appropriate security control measures for the management of anonymously processed information, including the prevention of leakage, loss, or damage."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Matters Concerning Anonymously Processed Information Produced by TRIAL Group", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u2460 TRIAL Group produces anonymously processed information based on the information provided and provides it to third parties on an ongoing basis."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          liWidth: "960",
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
            listType: "boldArticle",
            children: ["Items of Personal Information (items included in anonymously processed information)", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Attribute information\uFF08Gender, age categories, store visit distance, temporary ID (a substituted identifier from which the  TRIAL Member ID cannot be restored), family structure, caregiver/non-caregiver status, business/non-business status, matters concerning interests, etc.) and purchase information \uFF08date of purchase, store number, store name, products name, purchase quantity, and purchase amount\uFF09."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
            listType: "boldArticle",
            children: ["Method of provision", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Method of Uploading to the Password-protected Server"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u2461 If TRIAL Group produces anonymously processed information other than (1) in \u2460 above, TRIAL Group shall disclose the items of information related to individuals contained in the anonymously processed information."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Matters Concerning Anonymously Processed Information to be Provided to Third Parties", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Except in the case of \u201C(2) Matters Concerning Anonymously Processed Information Produced by TRIAL Group\u201D, when providing anonymously processed information to a third party, TRIAL Group shall disclose the items of information concerning individuals included in the anonymously processed information to be provided and the method of provision."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Prohibition of Identification", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "With respect to anonymously processed information, TRIAL Group shall not obtain information regarding the description deleted from the personal information or individual identification codes, or any information regarding the method of processing and shall not collate the anonymously processed information with other information in order to identify a principal concerned with personal information used to produce such anonymously processed information."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Contact for Inquiries and Complaints", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Please contact us with the information of \"13. Contact for Inquiries about Personal Information\" of the Privacy Policy."
        })]
      })]
    })]
  }),
  id: 'privacy6'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "7. Use of Cookies"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group obtains Cookies with the consent of the Customers and analyzes the combination of the Customer's \" TRIAL Member ID \", browsing history of TRIAL Group Websites, shopping history at TRIAL Group, service usage history, etc., to propose products and services, etc. that match the interests and preferences of the Customers and to provide information, marketing research, and advertising distribution."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Cookie is a mechanism for storing information about users who access the website. If you wish to opt out of Cookies, please click", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
        path: "/en/cookie-management",
        text: " here"
      }), "."]
    })]
  }),
  id: 'privacy7'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "8. Requests for Disclosure, Correction, Addition, Deletion, or Suspension of Personal Information by Customers"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: ["Customers may request the disclosure, correction, addition, deletion, or suspension of personal information registered by the Customers in a manner prescribed by TRIAL Group through the \"13. Contact for Inquiries about Personal Information \" section of the Privacy Policy. However, please note that we may not be able to disclose all or part of the personal information in the following cases.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u2460 Cases in which disclosure may harm the life, body, property, and other rights and interests of the Customers or third parties.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u2461 Cases in which disclosure may cause significant hindrance to the proper conduct of TRIAL Group business.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u2462 Cases in which disclosure may violate laws and regulations."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group shall quickly respond to requests for disclosure made by Customers and promptly correct any information that is found to be incorrect because of such requests. In such cases, from the standpoint of strict management of personal information, TRIAL Group may ask the disclosure requester to present documents proving the identity. Please also understand that the fees for the disclosure of personal information prescribed by TRIAL Group may be asked to be paid."
      })]
    })]
  }),
  id: 'privacy8'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "9. Handling of EU and UK Resident Data"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "In accordance with EU General Data Protection Regulation and its equivalent UK legislation (hereinafter collectively referred to as \"GDPR\"), this Article applies only to the handling of information that identifies or may identify persons residing in the European Union (in this Article, including Iceland, Liechtenstein and Norway, hereinafter referred to as \"EU\") and the United Kingdom (hereinafter referred to as \"EU and UK Resident Data\"; natural persons who are the subject of such EU and UK Resident Data are referred to as \"EU and UK Resident Data Subjects\"). The provisions of the Privacy Policy also apply to EU and UK Resident Data, except for \"10. Handling of Personal Information of Residents of the State of California, U.S.A.\"."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "EU and UK Resident Data collected by TRIAL Group and with whom it is shared are as follows. Please note that TRIAL Group does not sell EU and UK Resident Data."
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridTable */.R1, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "EU and UK Resident Data Categories and Examples"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Categories of Information Sources"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Business or Commercial Purposes of Use"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Categories of Third Parties with Whom EU and UK Resident Data is Shared"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListInGridRow */._b, {
            paddingLeft: "0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Personal identification information (name, e-mail address, etc.)."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Information regarding the place of employment or affiliation (company, corporation, department, position, etc.)."
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Direct collection from the EU and UK Resident Data Subjects."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Exchange of information, etc."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Shall not be shared."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: ["Information about Internet and other network activities (information collected by Cookies; if you wish to opt out of the Cookies, please click", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
            path: "/cookie-management",
            text: " here"
          }), ")."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Collection through browsing and using TRIAL Group's Websites."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Confirmation of access history, etc."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: ["TRIAL Group (Click", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
            path: "/company/overview/",
            text: " here"
          }), "for information on TRIAL Group companies other than TRIAL Holdings, Inc.)."]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      startValue: 1,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "When TRIAL Group handles EU and UK Resident Data as a controller under the GDPR (i.e. a person who determines how and for what purposes EU and UK Resident Data is handled), TRIAL Group shall clearly inform the EU and UK Resident Data Subjects of the purpose of the handling of EU and UK Resident Data and any other required GDPR notices, and obtain consent from the EU and UK Resident Data Subjects for such handling, unless there is a legal basis for otherwise."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "The explanation at the time of obtaining consent in the preceding paragraph shall be clearly stated in a manner that is clearly distinguishable from other matters, using clear and plain language, and in a manner that is easily understood and readily accessible."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group shall maintain records of consent to the handling of EU and UK Resident Data obtained from EU and UK Resident Data Subjects to be able to present proof of such consent in case it is requested."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group shall retain the EU and UK Resident Data listed in the table (1) if it is necessary for the \"Business or Commercial Purposes of Use\" listed in the table. If legal or accounting regulations require or permit retention for a longer period than is necessary, the retention period shall be determined after taking into consideration the business needs of TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "EU and UK Resident Data Subjects may receive their EU and UK Resident Data from TRIAL Group in a structured, commonly used, and machine-readable format and may transfer the received EU and UK Resident Data to other controllers without hindrance by TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "EU and UK Resident Data Subjects have the right to withdraw their consent at any time to the handling of the EU and UK Resident Data by TRIAL Group. The lawfulness of TRIAL Group's handling of EU and UK Resident Data shall not be affected by the withdrawal of consent by the EU and UK Resident Data Subjects."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group may transfer EU and UK Resident Data to countries outside the EU and the UK (including Japan) for handling. Japan has been granted an adequacy decision  by the European Commission recognizing that personal data protection in Japan is adequately ensured. Although transfer countries other than Japan, the EU, and the UK may not have the same privacy legislation as the country in which the EU and UK Resident Data Subject resides, TRIAL Group protects EU and UK Resident Data by entering standard contractual clauses based on GDPR with the data transfer recipient."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "If TRIAL Group handles EU and UK Resident Data as a processor under the GDPR (which means the subject acting on the written instructions by the controller), TRIAL Group shall handle such EU and UK Resident Data appropriately in accordance with the instructions by the controller of such EU and UK Resident Data."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "EU and UK Resident Data Subjects who wish to make inquiries concerning EU and UK Resident Data handled by TRIAL Group as a controller for those relating to the exercise of rights, etc. granted to data subjects under the GDPR, please contact us with the contact information in \"13. Contact for Inquiries about Personal Information\" of the Privacy Policy. When responding to the request, we shall need to confirm the identity of the data subject or the data subject's representative."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group shall respond in accordance with the provisions of the GDPR in the event that the data subject exercises any rights, etc. granted to it under the GDPR with respect to EU and UK Resident Data that TRIAL Group handles as a controller under the GDPR."
      })]
    })]
  }),
  id: 'privacy9'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "10. Handling of Personal Information of Residents of the State of California, U.S.A."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "In accordance with the California Consumer Privacy Act (hereinafter referred to as \"CCPA\"), this Article only applies to the handling of personal information (for the purpose of this Article, the information shall mean that identifies, relates to, describes, can be reasonably associated with, or can be reasonably linked directly or indirectly to, a particular consumer or household) of a resident of the State of California, U.S.A. The provisions of the Privacy Policy also apply to the personal information of residents of the State of California, USA, with the exception of \"9. Handling of EU and UK Resident Data\"."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Collection and Use of Personal Information", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Personal information collected by TRIAL Group from U.S. California residents during the past 12 months, the purposes for which it is used, and with whom it is shared are listed below. TRIAL Group does not sell and has not sold in the past 12 months, any personal information of U.S. residents of California (including personal information of minors) to the third parties."
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridTable */.R1, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Categories of Personal Information of the Residents of California, U.S.A and Examples"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Categories of Sources"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Business or commercial Purposes of Use"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Categories of Third Parties with Whom Personal Information of Residents of California, U.S.A.  is Shared"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListInGridRow */._b, {
            paddingLeft: "0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Personal identification information (name, e-mail address, etc.)."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Information regarding the place of employment or affiliation (company, corporation, department, position, etc.)."
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Direct collection from the residents of the State of California, U.S.A."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Exchange of information, etc."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Shall not be shared."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: ["Information about Internet and other network activities (information collected by Cookies; if you wish to opt out of the Cookies, please click", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
            path: "/cookie-management",
            text: " here"
          }), ")."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Collection through browsing and using TRIAL Group's Websites."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Confirmation of access history, etc."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: ["TRIAL Group (Click", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
            path: "/company/overview/",
            text: " here"
          }), "for information on TRIAL Group companies other than TRIAL Holdings, Inc.)."]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      liWidth: "960",
      marginLeft: "0.5",
      paddingLeft: "0.5",
      startValue: 1,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["Rights of Residents of the State of California, U.S.A.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " \u2460 Right to Demand Disclosure", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Residents of the State of California, U.S.A. have the right to request that TRIAL Group disclose the following information about their personal information collected, used, or shared by TRIAL Group in the past 12 months."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "disc",
            children: "Types of personal information collected."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "disc",
            children: "Types of personal information collection methods."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "disc",
            children: "Business or commercial purposes for which personal information is collected."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "disc",
            children: "Types of personal information shared for business purposes."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "disc",
            children: "Types of third parties with whom personal information is shared by type of personal information."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "disc",
            children: "Specific personal information about the residents of the State of California, U.S.A. who made the disclosure request."
          })]
        }), "\u2461 Right of Deletion", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Residents of the State of California, U.S.A. have the right to request certain personal information obtained by TRIAL Group be deleted."
        }), "\u2462 Right to Prohibit Discriminatory Treatment", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "TRIAL Group shall not discriminate against any residents of the State of California, U.S.A. on the basis of such residents' exercise of rights under the CCPA. However, the deletion of personal information may result in the inability to provide the services that were previously available to you. Please understand this in advance."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: "Residents of the State of California, U.S.A. who wish to make inquiries concerning exercising their rights, etc. under the CCPA, please contact us with the contact information in \"13. Contact for Inquiries about Personal Information \" of the Privacy Policy. In responding to such requests, we shall need to confirm that the person making the request is the person in question or his/her representative."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: "In the event TRIAL Group receives an exercise of rights, etc. under the CCPA from the residents of the State of California, U.S.A., TRIAL Group shall respond in accordance with the provisions of the CCPA."
      })]
    })]
  }),
  id: 'privacy10'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "11. Disclaimer Regarding Links to Third-Party Companies"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group is not responsible for matters relating to third-party companies that are not part of TRIAL Group and that are linked to this website. Such matters are governed by the terms and conditions and privacy policies of such companies."
    })]
  }),
  id: 'privacy11'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "12. Revisions to this Privacy Policy"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group may change or revise the Privacy Policy from time to time to comply with the Personal Information Protection Acts. In the event of any changes or revisions to the Privacy Policy, the details of such changes or revisions will be posted on this website. Please review the Privacy Policy carefully after such changes or revisions have been made."
    })]
  }),
  id: 'privacy12'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "13. Contact for Inquiries about Personal Information"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "If you have any questions about the Privacy Policy, or if you have any questions or concerns about TRIAL Group's handling of personal information, please contact us at the contact information below."
    })]
  }),
  id: 'privacy13'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: ["Customer Service Center,", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "TRIAL Company, Inc.\uFF08Reception hours: 9:00 a.m. to 10:00 p.m. \uFF09"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "TEL:0120-033-559", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Click ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
        path: "/contact/",
        text: "here"
      }), " for our web contact form.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "[For inquiries regarding SEIYU]\uFF08Reception hours: 9:00 a.m. to 10:00 p.m. (except during the New Year holidays)\uFF09"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "SEIYU Customer Service Center"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "TEL : 0120-360-373", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Click ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://www.seiyu.co.jp/contact/",
        target: "_blank",
        rel: "noreferrer",
        children: "here"
      }), " for our web contact form.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "\u201CSEIYU.com Gift-kan\u201D Customer Service Center,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "(Inquiries regarding the use of SEIYU.com Gift Store)", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Click ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://gift.the-seiyu.com/ec/guestInquiryEdit.html",
        target: "_blank",
        rel: "noreferrer",
        children: "here"
      }), " for our web contact form.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Date of Enactment : December 26, 2022", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Date of Last Revision : February 16, 2026"]
    })
  }),
  id: 'privacy14'
}];
var pvLinks = [[{
  name: '（ Collection and Management of Personal Information）',
  anchor: 'privacy1'
}, {
  name: '（Purpose of Use）',
  anchor: 'privacy2'
}, {
  name: '（Jointly Utilization of Personal Information）',
  anchor: 'privacy3'
}, {
  name: '（Provision to Third Partie）',
  anchor: 'privacy4'
}, {
  name: '（ Provision to Third Parties Located in Foreign Countries）',
  anchor: 'privacy5'
}, {
  name: '（Use of Anonymously Processed Information）',
  anchor: 'privacy6'
}, {
  name: '（ Use of Cookies）',
  anchor: 'privacy7'
}], [{
  name: '（Requests for Disclosure, Correction, Addition, Deletion, or Suspension of Personal Information by Customers）',
  anchor: 'privacy8'
}, {
  name: '（Handling of EU and UK Resident Data）',
  anchor: 'privacy9'
}, {
  name: '（Handling of Personal Information of Residents of the State of California, U.S.A.）',
  anchor: 'privacy10'
}, {
  name: '（Disclaimer Regarding Links to Third-Party Companies）',
  anchor: 'privacy11'
}, {
  name: '（ Revisions to this Privacy Policy)',
  anchor: 'privacy12'
}, {
  name: '（Contact for Inquiries about Personal Information)',
  anchor: 'privacy13'
}]]; //  外部送信ポリシー(External transmission)

var etItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "1. Introduction"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "In the smartphone application operated by TRIAL Group, \"TRIAL+\", \"SU-PAY\" (including services provided in conjunction with \"SU-PAY\"; hereinafter collectively referred to as the \"Service\"), and on the sites mentioned in \"3. Regarding External Transmission,\" we may use cookies and similar technologies to understand usage patterns, enhance convenience, perform statistical data analysis, and deliver, display, and measure the effectiveness of advertisements. For these purposes, information about users may be transmitted from the user's device to a server other than the user (\"External Transmission\")."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["In providing the Service, TRIAL Group, respecting privacy, may externally transmit user information (hereinafter referred to as \"User Information\"), such as user identifiers stored in cookies and device OS information, to the operators providing external services (hereinafter referred to as \"External Services\") necessary for the use of the external services.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*Note: Cookies are text data stored on the user's device through the browser when accessing the Service."]
    })]
  }),
  id: 'privacy1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "2. Opt-out Measures (Discontinuation of External Transmission)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Customers,etc. may, through browser settings, choose to discontinue external transmission. Please note that making such a choice may affect the normal use of the Service."
    })]
  }),
  id: 'privacy2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "3. Regarding External Transmission"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Information to be disclosed based on the External Transmission regulations of the Telecommunications Business Law (Article 27-12 of the Telecommunications Business Law) and requests from external service providers serving as transmission destinations, related to external services currently used by TRIAL Group for external transmission, is as follows. Please check the link in the \"Privacy Policy of the Transmission Destination\" for information on the purposes of using transmitted user information at the destination."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridTable2 */.JP, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Target Website(s) or Equivalent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Recipient Business/Service Name"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Content of the Transmitted Information"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Intended Use of the Transmitted Information by Our Company"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Privacy Policy or Equivalent of the Recipient"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Settings for Discontinuing External Transmission, etc."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://trial-holdings.inc/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://trial-holdings.inc/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.trial-net.co.jp/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.trial-net.co.jp/"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Plaid/KARTE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListInGridRow */._b, {
            paddingLeft: "0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Viewing history of pages within the site"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Duration of stay on each page"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Browser and OS type/version"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: ["Screen size", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Referrer"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Access source"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: ["Conversion data during form submission", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Advertising, marketing, and usage analysis"]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Advertising, Marketing, Usage Analysis"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://karte.io/karte-policy.html",
            target: "_blank",
            rel: "noreferrer",
            children: "https://karte.io/karte-policy.html"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://karte.io/optout/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://karte.io/optout/"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://trial-holdings.inc/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://trial-holdings.inc/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.trial-net.co.jp/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.trial-net.co.jp/"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Google LLC/Firebase"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: ["The content of the acquired information: ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://policies.google.com/technologies/partner-sites",
            target: "_blank",
            rel: "noreferrer",
            children: "https://policies.google.com/technologies/partner-sites"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Access Analysis "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://firebase.google.com/support/privacy?hl=ja#firebase_data_processing_and_security_terms",
            target: "_blank",
            rel: "noreferrer",
            children: "https://firebase.google.com/support/privacy?hl=ja#firebase_data_processing_and_security_terms"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://support.google.com/firebase/answer/9019185?hl=ja#zippy=%2C%E3%81%93%E3%81%AE%E8%A8%98%E4%BA%8B%E3%81%AE%E5%86%85%E5%AE%B98248?hl=ja",
            target: "_blank",
            rel: "noreferrer",
            children: "https://support.google.com/firebase/answer/9019185?hl=ja#zippy=%2C%E3%81%93%E3%81%AE%E8%A8%98%E4%BA%8B%E3%81%AE%E5%86%85%E5%AE%B98248?hl=ja"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://trial-holdings.inc/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://trial-holdings.inc/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.trial-net.co.jp/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.trial-net.co.jp/"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Intimatemerger"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListInGridRow */._b, {
            paddingLeft: "0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Unique ID stored in cookies"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Date and time of visit to the site or exposure to an advertisement"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "URL of the visited site"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Title and meta keywords of the visited site"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Referrer at the time of the visit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "IP address of the access source"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "User agent of the browser"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Language setting and character encoding setting of the browser"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Display area and color depth of the browser"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Delivery of content based on location information, acquisition of marketing information through understanding usage patterns, and service improvement."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://corp.intimatemerger.com/privacypolicy/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://corp.intimatemerger.com/privacypolicy/"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://corp.intimatemerger.com/privacypolicy/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://corp.intimatemerger.com/privacypolicy/"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: ["SU-PAY", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "TRIAL\uFF0B"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "unerry Inc."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListInGridRow */._b, {
            paddingLeft: "0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Device information such as smartphone model, manufacturer, device OS version, and language settings"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Advertising identifier (IDFA or Google Advertising ID, etc.)."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Location information related to smartphones."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Information about beacons acquired by the app users in the vicinity."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "IP address."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Information related to the usage of this app (permission for location information usage, status of Bluetooth (on/off), viewing and opening date/time of push content, information about reacted beacons, etc.)."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: ["Segment information of app users determined as necessary by the provider of this app (age, gender, occupation, etc., excluding personal information).", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " *For more details, please refer to ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://su-pay.jp/terms/",
                target: "_blank",
                rel: "noreferrer",
                children: "https://su-pay.jp/terms/"
              }), "."]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Delivery of content based on location information, acquisition of marketing information through understanding usage patterns, and service improvement. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.unerry.co.jp/privacy/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.unerry.co.jp/privacy/"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.unerry.co.jp/privacy/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.unerry.co.jp/privacy/"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* GridRow */.Jn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://miyawaka-toranoyu.com/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://miyawaka-toranoyu.com/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://kominka-neri.com/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://kominka-neri.com/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://toranoyu.com/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://toranoyu.com/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.kuoritei.com/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.kuoritei.com/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.sengokuharatoranoyu.com/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://www.sengokuharatoranoyu.com/"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://hakonekuoritei.com/",
            target: "_blank",
            rel: "noreferrer",
            children: "https://hakonekuoritei.com/"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Microsoft Corporation/ Clarity"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListInGridRow */._b, {
            paddingLeft: "0.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Viewing history of the websites (date/time, URL, category, referrer, etc.)"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Location information of the device (IP address, GPS info, etc.)"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
              listType: "disc",
              children: "Information identifying the user or device (User ID, browser/device identifier, etc.)"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Analysis of website viewing status"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://privacy.microsoft.com/ja-jp/privacystatement",
            target: "_blank",
            rel: "noreferrer",
            children: "https://privacy.microsoft.com/ja-jp/privacystatement"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "\u2015"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Additionally, in addition to the external transmissions listed above, TRIAL Group also externally transmit information necessary for providing the Service. This includes, but is not limited to, information required for tasks such as retaining entered information, user authentication, security measures for detecting and preventing unauthorized access, information necessary for network management such as detecting and addressing malfunctions or errors, and more."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Date of Enactment : September 05, 2023", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Date of Last Revision : February 16, 2026"]
    })]
  }),
  id: 'privacy3'
}];
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Legal/Index/index.tsx
var Index = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/components/enlayouts/Legal/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(73799);
;// CONCATENATED MODULE: ./src/components/enpages/Legal/Privacy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var sectionTitle = {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
      children: ["Privacy Policy", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
    })
  })
};
var secondsectionTitle = {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: "External Transmission of User Information"
    })
  })
};

var tSummary = /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
  children: ["TRIAL Holdings, Inc. and its group companies *(hereinafter referred to as \"TRIAL Group\"), in order for customers, business partners, applicants for employment, and shareholders (hereinafter collectively referred to as the \"Customers\") to use TRIAL Group's stores, websites, mobile applications and services (hereinafter referred to as the \"Websites\") with peace of mind, shall comply with the Act on the Protection of Personal Information, its related laws, regulations, and guidelines (hereinafter referred to as the \"Personal Information Protection Acts\") and manage the personal information of the Customers with the utmost care. TRIAL Group has established this Privacy Policy (hereinafter referred to as the \"Privacy Policy\") as its basic policy for the handling of personal information and shall strive to handle the personal information of the Customers collected by TRIAL Group in a legal and appropriate manner. In addition, the Customers using the Websites are deemed to have agreed to the Privacy Policy.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "* \"TRIAL Group\" shall mean TRIAL Holdings, Inc., together with  its consolidated subsidiaries and affiliates accounted for under the equity method, excluding SU-PAY Co., Ltd.  The privacy policy applicable to SU-PAY Co., Ltd. shall be separately stipulated.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "This Privacy Policy does not apply to SU-PAY Co., Ltd. and SEIYU Net Supermarket service.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*Click ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "https://su-pay.jp/prepaid/terms/",
    target: "_blank",
    rel: "noreferrer",
    children: "here"
  }), " for the privacy policy of SU-PAY Co., Ltd.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*Click ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "https://netsuper.rakuten.co.jp/seiyu/info/privacy/",
    target: "_blank",
    rel: "noreferrer",
    children: "here"
  }), " for the privacy policy of SEIYU Net Super."]
});

var PrivacyPage = function PrivacyPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Privacy Policy",
      description: "The privacy policy for TRIAL Holdings, Inc.",
      ogp: {
        type: 'article',
        url: 'en/legal/privacy-policy/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PrivacyContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, _objectSpread({}, sectionTitle)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SummaryDiv */.U5, {
        children: tSummary
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 46,
          sp: 35
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 84,
        listType: "article",
        links: pvLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 35,
          sp: 40
        }
      }), pvItems.map(function (_ref, index, array) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < array.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 100,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, _objectSpread({}, secondsectionTitle)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), etItems.map(function (_ref2, index, array) {
        var children = _ref2.children,
            id = _ref2.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < array.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

PrivacyPage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: ''
  };
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Legal',
    path: '/en/legal/'
  }, {
    name: 'Privacy Policy',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var PrivacyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Privacy__PrivacyContainer",
  componentId: "sc-80906l-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 68px;}#privacy7{margin-top:-105px;padding-top:105px;}@media screen and (max-width:1047px){#privacy7{margin-top:-53px;padding-top:53px;}}"]);
;// CONCATENATED MODULE: ./src/pages/en/legal/privacy-policy.tsx


/***/ }),

/***/ 3422:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/privacy-policy",
      function () {
        return __webpack_require__(79837);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,4591,9774,2888,179], function() { return __webpack_exec__(3422); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);